<script>
    import { sgettext } from "../../../i18n";
    import { PATH_PREFIX } from '../../../apiUrls.js';
    import TypeBadge from "../../DashBoard/TypeBadge.svelte";
    import ImageTextCellRenderer from "./ImageTextCellRenderer.svelte";

    export let name;
    export let sequenceName;
    export let element_instances;
    export let sequenceRowSpan;
    export let roleIndex;
    export let sequenceIndex;
    export let activityVersionId;

    const getImageUrl = item => item?.icon ? item.icon.url : '';

    const getBackground = expired => expired ? "background-color: #fcd2d7;" : "";

    function shouldMergeWithNext(currentIndex) {
        if (currentIndex < 0 || currentIndex + 1 >= element_instances.length) return false;
        
        const currentRisk = element_instances[currentIndex].material_risk;
        const nextRisk = element_instances[currentIndex + 1].material_risk;
        
        if (!currentRisk || !nextRisk) return false;

        return currentRisk.mechanism.id === nextRisk.mechanism.id &&
               currentRisk.hazard.id === nextRisk.hazard.id &&
               currentRisk.control.id === nextRisk.control.id;
    }

    function calculateMergeRowSpan(currentIndex) {
        if (currentIndex < 0 || currentIndex >= element_instances.length || !element_instances[currentIndex].material_risk) return 1;
        let span = 1;
        while (shouldMergeWithNext(currentIndex)) {
            span++;
            currentIndex++;
        }
        return span;
    }

    function truncateName(name, length=30) {
        length = (length < 1) ? 30 : length
        if (name.length > length) {
            return name.substring(0, length) + "..."
        }
        return name
    }
</script>

{#each element_instances as { element_id, step, type, name: elementName, material_risk, work_sequence_id }, elementIndex}
  {#if material_risk}
    <tr>
      {#if elementIndex === 0}
        <td rowspan={sequenceRowSpan}>
          <div class="label-container">
            <div class="text">
              {sequenceName}
            </div>
          </div>
        </td>
      {/if}

      <td>{step + 1}</td>
      <td><TypeBadge data={type} /></td>
      <td>
        <a
          href={`${PATH_PREFIX}/sw/builder/activity_sequence_builder/${activityVersionId}/worksequence/${work_sequence_id}/element_instance/${element_id}/`}
          target="_blank" rel="noopener noreferrer">{elementName}</a
        ></td
      >

      {#if !shouldMergeWithNext(elementIndex - 1)}
        <td
          class={material_risk.expired ? 'red-border-left' : ''}
          style={getBackground(material_risk.expired)}
          rowspan={calculateMergeRowSpan(elementIndex)}
        >
          <ImageTextCellRenderer
            imageSrc={getImageUrl(material_risk.mechanism.energy_type)}
            mainText={material_risk.mechanism.energy_type.name}
            subText={material_risk.mechanism.name}
            altText={material_risk.mechanism.name}
            invalid={material_risk.expired}
          />
        </td>
        <td
          class={material_risk.expired ? 'red-border' : ''}
          style={getBackground(material_risk.expired)}
          rowspan={calculateMergeRowSpan(elementIndex)}
        >
          <ImageTextCellRenderer
            imageSrc={getImageUrl(material_risk.hazard)}
            mainText={material_risk.hazard.name}
            subText={material_risk.hazard.description}
            altText={material_risk.hazard.name}
          />
        </td>
        <td
          class={material_risk.expired ? 'red-border-right' : ''}
          style={getBackground(material_risk.expired)}
          rowspan={calculateMergeRowSpan(elementIndex)}
        >
          <ImageTextCellRenderer
            imageSrc={getImageUrl(material_risk.control)}
            mainText={material_risk.control.name}
            subText={material_risk.control.description}
            altText={material_risk.control.name}
          />
        </td>

        <td rowspan={calculateMergeRowSpan(elementIndex)}>
          {#if material_risk.control_owner}
            <a
              style="overflow-wrap: break-word;"
              class="text-primary"
              href="mailto:{material_risk.control_owner}"
              >{material_risk.control_owner}</a
            >
            <p
                class="text-secondary mt-2" 
                style="overflow-wrap: break-word;" 
                title="{material_risk.control_owner_name}"
            >
                <em>{truncateName(material_risk.control_owner_name)}</em>
            </p>
          {:else}
            {sgettext('$$NOT_CONFIGURED$$')}
          {/if}
        </td>
      {/if}
    </tr>
  {/if}
{/each}

<style>
  .red-border {
    border-top: 2px solid red;
    border-bottom: 2px solid red;
  }

  .red-border-left {
    border-top: 2px solid red;
    border-bottom: 2px solid red;
    border-left: 2px solid red;
  }

  .red-border-right {
    border-top: 2px solid red;
    border-bottom: 2px solid red;
    border-right: 2px solid red;
  }

  .label-container .text {
    font-weight: bold;
    font-size: medium;
  }

  tr {
    border-bottom: 1px solid #e0e0e0;
  }

  td {
    padding: 12px;
    text-align: left;
    vertical-align: middle;
    border-right: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
  }

  tr:hover {
    background-color: #f5f5f5;
  }

  tr:nth-child(even) {
    background-color: #fafafa;
  }
</style>
